export default "__VITE_PUBLIC_ASSET__da52dfe2__"